import { db_loading_type } from "../interfaces";

declare const db_loading: db_loading_type;

// 重置 indexedDB
export default function destroy(db_name: string) {
  return new Promise((resolve, reject) => {
    const db_loading_this = db_loading[db_name];
    if (db_loading_this) db_loading_this.close();
    delete_db(db_name)
      .then(() => {
        // console.info('Database ' + db_name + ' deleted successfully');
        db_loading[db_name] = undefined;
        resolve(undefined);
      })
      .catch((_err) => {
        // console.error(err);
        db_loading[db_name] = undefined;
        reject();
      });
  });

  // 逐筆刪除 indexedDB 資料庫
  function delete_db(db_name: string) {
    return new Promise((resolve, reject) => {
      const DBRequest = indexedDB.deleteDatabase(db_name);
      DBRequest.onerror = (): void => {
        // console.error('Error deleting database ' + db_name + '.');
        reject();
      };
      DBRequest.onsuccess = (): void => {
        // console.info('Database ' + db_name + ' deleted successfully');
        resolve(undefined);
      };
    });
  }
}
